messenger.listen(messenger.topics.DOM_READY, () => {
  let resizeLock = false;
  // get all product cards
  const productCards = document.querySelectorAll('product-card');

  if (productCards.length === 0) {
    let retryCount = 0;
    const retryInterval = setInterval(() => {
      if (retryCount > 20) {
        clearInterval(retryInterval);
        return;
        
      }
      const productCards = document.querySelectorAll('product-card');
      if (productCards.length !== 0) {
        clearInterval(retryInterval);
        setProductCardHeights(productCards);
      }
      retryCount++;
    }, 500);
    return;
  }
  setProductCardHeights(productCards);
});

function getDesktopColumns() {
  if (window.innerWidth < 750) {
    return 1;
  } else if (window.innerWidth < 990) {
    return 3;
  } else {
    return 4;
  }
}

function cardHasVariantSelector(card) {
  if (card.querySelector('swiper-variants-desktop')) {
    return true;
  }
  if (card.querySelector('variant-dropdown-cp')) {
    return true;
  }
  return false;
}

function returnVariantSelectorIfRowHasVariantSelector(row) {
  for (let j = 0; j < row.length; j++) {
    const element = row[j].closest('product-card');
    if (element.querySelector('swiper-variants-desktop')) {
      const variantSelector = element.querySelector('swiper-variants-desktop');
      return variantSelector;
    } else if (element.querySelector('variant-dropdown-cp')) {
      const variantSelector = element.querySelector('variant-dropdown-cp');
      return variantSelector;
    }
  }
  return null;
}

function setCardUiToMobile(productCards) {
  for (let i = 0; i < productCards.length; i++) {
    const card = productCards[i];
    const titleWrapper = card.querySelector('.card-title-height-wrapper');
    titleWrapper.style.height = 'auto';
    const placeholder = card.querySelector('.variant-select-placeholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }
}

function setProductCardHeights(productCards) {
  // console.log('setting product card heights');
  // return on mobile
  if (window.innerWidth < 750) {
    // console.log(
    //   'window width less than 750, setting title wrappers to auto & hide placeholders'
    // );
    setCardUiToMobile(productCards);
    return;
  }

  // console.log("Not on mobile, proceeding...");
  // get desktop columns
  const desktopColumns = getDesktopColumns();

  let rowArray = [];
  let thisRow = [];

  // loop through product cards and push them into rows
  for (let i = 0; i < productCards.length; i++) {
    const card = productCards[i];
    thisRow.push(card);
    if (thisRow.length === desktopColumns || i === productCards.length - 1) {
      rowArray.push(thisRow);
      thisRow = [];
    }
  }

  // loop through rows
  for (let i = 0; i < rowArray.length; i++) {
    const row = rowArray[i];

    // get variant selector if row has variant selector
    const variantSelector = returnVariantSelectorIfRowHasVariantSelector(row);

    // get max height of title wrappers
    let maxHeight = 0;
    for (let j = 0; j < row.length; j++) {
      const wrapper = row[j].querySelector('.card-title-height-wrapper');
      if (wrapper.offsetHeight > maxHeight) {
        maxHeight = wrapper.offsetHeight;
      }
    }

    // set title wrapper heights
    for (let j = 0; j < row.length; j++) {
      const wrapper = row[j].querySelector('.card-title-height-wrapper');
      wrapper.style.height = `${maxHeight}px`;
    }

    // set card heights if row has variant selector
    if (variantSelector) {
      // console.log('variant selector in row', variantSelector);
      for (let j = 0; j < row.length; j++) {
        const card = row[j];
        if (!cardHasVariantSelector(card)) {
          // console.log('setting card height', card);
          const placeholder = card.querySelector('.variant-select-placeholder');
          placeholder.style.display = 'block';
          placeholder.style.height = `${variantSelector.offsetHeight}px`;
        }
      }
    }
  }

  // loop through rows again and set card heights to the max card height in the row
  // for (let i = 0; i < rowArray.length; i++) {
  //   const row = rowArray[i];
  //   let maxHeight = 0;
  //   for (let j = 0; j < row.length; j++) {
  //     const card = row[j];
  //     if (card.offsetHeight > maxHeight) {
  //       maxHeight = card.offsetHeight;
  //     }
  //   }
  //   for (let j = 0; j < row.length; j++) {
  //     const card = row[j];
  //     console.log('setting card height', card);
  //     console.log('maxHeight', maxHeight);
  //     card.style.height = `${maxHeight}px`;
  //   }
  // }

}

window.addEventListener('resize', () => {
  const productCards = document.querySelectorAll('product-card');
  setProductCardHeights(productCards);
});
window.addEventListener('orientationchange', () => {
  const productCards = document.querySelectorAll('product-card');
  setProductCardHeights(productCards);
});
